import { ErrorMapping } from 'core/types/error-mapping';

export const NAME_FIELD = 'name';

export const CUSTOM_NOTIFICATION_NAME_ERROR_MAPPINGS: ErrorMapping[] = [
    { field: NAME_FIELD, errorCode: 'E_POC_SC_CAS_0008', type: 'duplicated' },
];
